module.exports = __webpack_public_path__ + "static/img/bank-top.78995df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank-top.png
// module id = U/TL
// module chunks = 0